import { appendIf } from '@btime/helpers'

const validate = (form, variables, setErrors) => {
  const errors = []

  errors.push(
    ...appendIf(!form?.payload?.template, { path: ['payload', 'template'], message: 'Campo obrigatório' }),
    ...appendIf(!form?.payload?.from, { path: ['payload', 'from'], message: 'Campo obrigatório' }),
    ...appendIf(!form?.payload?.to, { path: ['payload', 'to'], message: 'Campo obrigatório' })
  )

  if (variables && variables.length > 0) {
    variables.forEach(variable => {
      const value = form?.payload?.template?.contentVariables?.[variable]
      if (!value) {
        errors.push({
          path: ['payload', 'template', 'contentVariables', variable],
          message: 'Campo obrigatório'
        })
      }
    })
  }

  setErrors(errors)
  return errors.length === 0
}

export default validate
